/**
 * Unistyles configuration — imports theme from the shared @visioni/a3s-ui package
 * and configures the StyleSheet singleton.
 *
 * This file MUST be imported in the app entry point (index.ts) before any
 * component renders, so that StyleSheet.configure() runs first.
 */
import { StyleSheet } from "react-native-unistyles";
import { appThemes, breakpoints } from "@visioni/a3s-ui/theme";

// Re-export everything from the shared package so existing `@src/unistyles`
// consumers continue to work without changing their imports.
export {
  colorPalettes,
  spacing,
  shadows,
  lightTheme,
  darkTheme,
  appThemes,
  breakpoints,
  type AppThemes,
  type AppBreakpoints,
  type AppColorPalette,
  type AppColorPaletteShades,
  type AppSpacing,
} from "@visioni/a3s-ui/theme";

// Configure the Unistyles singleton — must happen before any StyleSheet.create
StyleSheet.configure({
  settings: {
    adaptiveThemes: true,
  },
  themes: appThemes,
  breakpoints,
});
